import React from 'react'

import { TemplatesPDF } from '@interco/cp-react-ui-lib'

const PublicoVulneravel = () => <TemplatesPDF.PagePublicoVulneravel />

export default PublicoVulneravel
